import React from 'react';
import './Pagination.scss';
import { Icons } from '../Icons/Icons';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const renderPageNumbers = () => {
    const pages = [];

    pages.push(
      <button
        key="prev"
        className="pagination-nav pagination-nav-prev"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        {Icons.ArrowRight}
        Previous
      </button>
    );

    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
        pageNumbers.push(
          <button
            key={i}
            className={`pagination-number ${currentPage === i ? 'active' : ''}`}
            onClick={() => onPageChange(i)}
          >
            {i}
          </button>
        );
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        pageNumbers.push(
          <span key={`ellipsis-${i}`} className="pagination-ellipsis">
            ...
          </span>
        );
      }
    }

    pages.push(
      <div className="pagination-items" key="items">
        {pageNumbers}
      </div>
    );

    pages.push(
      <div className="pagination-mobile-info" key="mobile-info">
        Page {currentPage} of {totalPages}
      </div>
    );

    pages.push(
      <button
        key="next"
        className="pagination-nav pagination-nav-next"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
        {Icons.ArrowRight}
      </button>
    );

    return pages;
  };

  return <div className="pagination">{renderPageNumbers()}</div>;
};
